import { render, staticRenderFns } from "./RecipeItemImage.vue?vue&type=template&id=45884005&"
import script from "./RecipeItemImage.vue?vue&type=script&lang=js&"
export * from "./RecipeItemImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports